import   React            ,
       { useState         ,
         useEffect        }  from 'react';

import   classNames          from 'classnames';
import   styles              from './BroadcastingChannelCategoryRow.module.scss';

import { BroadcastingChannelCategory }  from '../../../dataTypes/broadcastingManagment/types';
import   Toggle              from '../../widget/inputs/Toggle';
import   Icon                from '../../widget/images/Icon';


interface BroadcastingChannelCategoryRowProps {
  category                 : BroadcastingChannelCategory;
  categorySetLenght        : number;
  onNameChange             : (index: number, newName: string) => void;
  onArrowClick             : (index: number, direction: 'up' | 'down') => void;
  onDeleteClick            : (category: BroadcastingChannelCategory) => void;
  onVisibilityChange       : (index: number, newState: boolean) => void;
}



export const BroadcastingChannelCategoryRow = ({ category,
                                   categorySetLenght,
                                   onNameChange,
                                   onArrowClick,
                                   onDeleteClick,
                                   onVisibilityChange }: BroadcastingChannelCategoryRowProps) => {

  const [ oldCategoryName  , setOldCategoryName  ] = useState(category.name);
  const [ newCategoryName  , setNewCategoryName  ] = useState(category.name);
  const [ modificationFlag , setModificationFlag ] = useState(false);

  useEffect(() => {
    setOldCategoryName(category.name);
    setNewCategoryName(category.name);
    setModificationFlag(false);
  }, [category.name]);

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setNewCategoryName(v);
    setModificationFlag(v !== oldCategoryName);
  };

  const handleChangesConfirm = () => {
    if (newCategoryName !== oldCategoryName) {
      onNameChange(category.rank - 1, newCategoryName);
      setOldCategoryName(newCategoryName);
      setModificationFlag(false);
    }
  };

  return (
    <div className={classNames(styles.row)}>

      <div className={classNames(styles.column, styles.rank)}>
        {category.rank}
      </div>

      <div className={classNames(styles.column, styles.name)}>
        <input type="text" value={newCategoryName} onChange={handleNameChange} />
      </div>

      <div className={classNames(styles.column, styles.nameSaving)}>
        {modificationFlag && (
           <Icon name       = "floppyDisk"
                 onClick    = {handleChangesConfirm}
		         color      = "var(--color-Icon-FG)"
                 hoverColor = "var(--color-Icon-hover-FG)" />
        )}
      </div>

      <div className={classNames(styles.column, styles.actions)}>
        {category.rank > 1 && (
          <Icon name       = "topArrow2"
                onClick    = {() => onArrowClick(category.rank - 1, 'up')}
                color      = "#215DAE"
                hoverColor = "#215DAE" />
        )}
        {category.rank < categorySetLenght && (
          <Icon name       = "bottomArrow2"
                onClick    = {() => onArrowClick(category.rank - 1, 'down')}
                color      = "#215DAE"
                hoverColor = "#215DAE" />
        )}
      </div>

      <div className={classNames(styles.column, styles.delete)}>
        <Icon name       = "trashCan"
              onClick    = {() => onDeleteClick(category)}
              color      = "#DE6B70"
              hoverColor = "#DE6B70" />
      </div>

      <div className={classNames(styles.column, styles.visibility)}>
        <Toggle
          checked  = {category.visible}
          form     = "switch"
          onChange = {() => onVisibilityChange(category.rank - 1, !category.visible)}
        />
      </div>

    </div>
  );
};

export default BroadcastingChannelCategoryRow;
